import React from 'react';
import {
  Box,
  Steps,
} from '@chakra-ui/react';
import { FaCheck } from 'react-icons/fa';

const CorporateStepper = ({ steps, activeStep }) => {
  return (
    <Steps.Root index={activeStep} count={steps.length} orientation="horizontal" size="lg" colorPalette="blue">
      <Steps.List>
        {steps.map((step, index) => (
          <Steps.Item key={index} index={index} title={step.title} description={step.description}>
             <Steps.Indicator 
                bg={index < activeStep ? "blue.500" : undefined} 
                borderColor={index < activeStep ? "blue.500" : undefined}
                color={index < activeStep ? "white" : undefined}
             >
                {index < activeStep ? <FaCheck /> : null}
             </Steps.Indicator>
             <Box flexShrink="0" ml={2}>
                 <Steps.Title>{step.title}</Steps.Title>
                 <Steps.Description>{step.description}</Steps.Description>
             </Box>
             <Steps.Separator />
          </Steps.Item>
        ))}
      </Steps.List>
    </Steps.Root>
  );
};

export default CorporateStepper;
